<mat-toolbar>
  <h1>Gym Finder Search Filters</h1>
</mat-toolbar>

<mat-card class="card">
  <mat-card-title class="flex-display">
    Search Filters
    @if (searchFiltersLoading) {
      <mat-spinner [diameter]="28"></mat-spinner>
    }
    <div class="spacer"></div>
    <button
      mat-mini-fab
      color="primary"
      matTooltip="Add new search filter"
      (click)="onAddNewSearchFilter()">
      <mat-icon>add</mat-icon>
    </button>
  </mat-card-title>

  <mat-card-content class="list">
    @if (
      !searchFiltersLoading && (!searchFilters || searchFilters.length === 0)
    ) {
      <div>There are no search filters. Please add a new one.</div>
    }
    @if (searchFilters && filters) {
      <mat-accordion multi>
        @for (
          searchFilter of searchFilters;
          track searchFilter;
          let i = $index
        ) {
          <mat-expansion-panel
            [expanded]="expandedSearchFilterPanel === i"
            (opened)="onSearchFilterPanelOpened(i)"
            (closed)="onSearchFilterPanelClosed(i)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                @if (searchFilterModified[i]) {
                  <span>*&nbsp;</span>
                }
                {{ searchFilter.slug }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <gymfinder-search-filter
              [searchFilter]="searchFilter"
              (searchFilterChange)="onSearchFilterChange($event, i)"
              [availableFilters]="filters"></gymfinder-search-filter>
            <mat-action-row>
              @if (savingSearchFilters[i]) {
                <mat-spinner [diameter]="16"></mat-spinner>
              }
              <button
                mat-raised-button
                (click)="cancelSearchFilterEdit(i)"
                [disabled]="!searchFilterModified[i]">
                Cancel
              </button>
              <button
                mat-raised-button
                color="primary"
                (click)="saveSearchFilter(searchFilter, i)"
                [disabled]="!searchFilterModified[i]">
                Save Search Filter
              </button>
            </mat-action-row>
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
  </mat-card-content>
</mat-card>

<mat-card class="card">
  <mat-card-title class="flex-display">
    Filters
    @if (filtersLoading) {
      <mat-spinner [diameter]="28"></mat-spinner>
    }
    <div class="spacer"></div>
    <button
      mat-mini-fab
      color="primary"
      matTooltip="Add new filter"
      (click)="onAddNewFilter()">
      <mat-icon>add</mat-icon>
    </button>
  </mat-card-title>

  <mat-card-content class="list">
    @if (!filtersLoading && (!filters || filters.length === 0)) {
      <div>There are no search filters. Please add a new one.</div>
    }
    @if (
      studioTypes &&
      filters &&
      activities &&
      services &&
      equipmentsToBring &&
      gymInfos &&
      gymTypes &&
      gymEquipments &&
      geniusFeatures
    ) {
      <mat-accordion multi>
        @for (filter of filters; track filter; let i = $index) {
          <mat-expansion-panel
            [expanded]="expandedFilterPanel === i"
            (opened)="onFilterPanelOpened(i)"
            (closed)="onFilterPanelClosed(i)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                @if (filterModified[i]) {
                  <span>*&nbsp;</span>
                }
                {{ filter.slug }}
              </mat-panel-title>
              <mat-panel-description>
                {{ getLogicalExpression(filter) }}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <gymfinder-filter
              [filter]="filter"
              [studioTypes]="studioTypes"
              [activities]="activities"
              [services]="services"
              [gymTypes]="gymTypes"
              [gymEquipments]="gymEquipments"
              [equipmentsToBring]="equipmentsToBring"
              [gymInfos]="gymInfos"
              [networks]="networks"
              [geniusFeatures]="geniusFeatures"
              (filterChange)="onFilterChange($event, i)"></gymfinder-filter>
            <mat-action-row>
              @if (savingFilters[i]) {
                <mat-spinner [diameter]="16"></mat-spinner>
              }
              <button
                mat-raised-button
                (click)="cancelFilterEdit(i)"
                [disabled]="!filterModified[i]">
                Cancel
              </button>
              <button
                mat-raised-button
                color="primary"
                (click)="saveFilter(filter, i)"
                [disabled]="!filterModified[i]">
                Save Filter
              </button>
            </mat-action-row>
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
  </mat-card-content>
</mat-card>
